import axios from "axios";
import {closeModal, openModal, url} from "../../utilities";
import Spinner from "../../spinner";
import {toastAlert} from "../../toastAlert";
import {buildItemFromForm, itemFormCommon} from "./item-form-common";
import * as $ from "jquery";
import {emptyForm, enableFormBack, handleApiForm} from "../../forms";
import {confirmModal} from "../../confirmModal";



export const animal = () => {

    const body = $('body');

    let collectionCentreOptions = $('#groupHuntingAddAnimal_collection_centre_id > option').clone();

    if (parseInt($('#groupHuntingAddAnimal_animal_type_id, #groupHuntingEditAnimal_animal_type_id').children("option:selected").data('is_big')) === 1) {
        $(".animals").show();
        $(".edit-animals").show();
    } else {
        $(".edit-animals").hide();
        $(".animals").hide();
    }

    $('#groupHuntingAddAnimal_animal_type_id').on('change', async function (e) {
        e.preventDefault();

        let user_association = $('.user_association');

        let id = $(this).children("option:selected").val();

        try {
            let response = await axios.get(url(`api/app/dictionary/animals?type_id=${id}&only_from_plan=true`));
            let select = $("#groupHuntingAddAnimal_animal_id");

            $(this).children("option[value='0']").remove();

            if (parseInt($(this).children("option:selected").data('is_big')) === 1) {
                $(".weight").show();
            } else {
                $(".weight").hide();
            }

            if($(this).children("option:selected").data('has_many_animals')){
                $(".animals").show();
            }else{
                $(".animals").hide();
            }

            $('.animal_intended_use').show();
            if (parseInt($('#groupHuntingAddAnimal_animal_intended_use').children("option:selected").val()) === 1) {
                $('.centres').show();
            }
            $('.identifier').show();
            user_association.show();
            if (parseInt(user_association.children("option:selected").val()) === 0) {
                $('.guest_full_name').show();
            }
            $("#groupHuntingAddAnimal_quantity").val(1);

            $('.btn-add').show();
            $('.btn-next').hide();
            select.empty();

            let data = response.data;

            for (let animal of data.animals) {
                select.append(`<option value=${animal.id}>${animal.name}</option>`);
            }

        } catch (err) {
            toastAlert('Wystąpił błąd podczas dodawania zwierzyny', {type: 'danger'})
        }
    });


    body.on('click', '.btnDeleteAnimal', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć to zwierzę?', {color: 'danger'});
        if (!confirm) return;

        let id = $(this).data('id');

        try {
            const response = await axios.post(window._DELETE_ANIMAL_URL.replace('REPLACE_ID', id));
            console.log((response));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let table = $('#huntingAnimalsTable').DataTable();
            let row = table.$(`tr[data-id=${$(this).data('id')}]`)
            table.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto zwierzę');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia', {type: 'danger'})
        }
    })


    let centre_values = null;
    let data;

    $('#groupHuntingAddAnimal_animal_intended_use_id').on('change', async function (e) {
        e.preventDefault();

        let id = $(this).children("option:selected").val();

        try {

            if (centre_values == null) {
                let response = await axios.get(url(`api/app/reckonings/collection-centres?intended_use_id=${id}`));
                data = response.data;

            } else {
                data = centre_values;
            }

            let select = $("#groupHuntingAddAnimal_collection_centre_id");

            if (parseInt($(this).children("option:selected").val()) === 1) {
                centre_values = data;
                $(".centres").show();
            } else {
                $(".centres").hide();
            }

            select.empty();

            if (data.centres) {
                select.append(`<option value=0>Brak</option>`)
                for (let centre of data.centres) {
                    select.append(`<option value=${centre.id}>${centre.short_name}</option>`);
                }
            }

        } catch (err) {
            toastAlert('Wystąpił błąd podczas wyboru miejsca skupu', {type: 'danger'})
        }
    });

    $('#groupHuntingAddAnimal_is_animal_dead').on('change', async function (e) {
        e.preventDefault();

        try {

            let select = $("#groupHuntingAddAnimal_is_animal_dead");

            if ($(this).prop('checked')) {
                $(".death").show();
            } else {
                $(".death").hide();
                $("#groupHuntingAddAnimal_animal_intended_use_id").val(0);
            }

            select.empty();


        } catch (err) {
            toastAlert('Wystąpił błąd podczas dodawania zwierzyny', {type: 'danger'})
        }
    });


    $('#groupHuntingAddAnimal_user_association_id').on('change', async function (e) {
        e.preventDefault();

        if (parseInt($(this).children("option:selected").val()) === 0) {
            $('.guest_full_name').show();
        } else {
            $('.guest_full_name').hide();

        }
    });


    $('#groupHuntingEditAnimal_is_animal_dead').on('change', async function (e) {
        e.preventDefault();

        try {

            let select = $("#groupHuntingEditAnimal_is_animal_dead");

            if ($(this).prop('checked')) {
                $(".death").show();
            } else {
                $(".death").hide();
                $("#groupHuntingEditAnimal_animal_intended_use_id").val(0);
            }

            select.empty();


        } catch (err) {
            toastAlert('Wystąpił błąd podczas dodawania zwierzyny', {type: 'danger'})
        }
    });


    $('.btn-next').on('click', async function (e) {

        let btnBack = $('.btn-back');

        e.preventDefault();

        $('.btn-decline').hide();
        btnBack.removeClass('d-none');
        btnBack.show();

        $('.dialog-add').addClass('modal-lg modal-xl');


        let quantity = $('#groupHuntingAddAnimal_quantity').val();

        $('.animal_types').hide();
        $('.animals').hide();
        $('.quantity').hide();
        $('.btn-add').show();
        $('.btn-next').hide();


        $('.title-add').html('Szczegóły (' + $('#groupHuntingAddAnimal_animal_type_id').children("option:selected").html() + ' - ' +
            $('#groupHuntingAddAnimal_animal_id').children("option:selected").html() + ')');

        let row = $('.animals-col-add');

        let table = $(`

        <table class="table table-striped table-hover table-bordered table-details w-100">
        <thead>
        <tr>
            <th>Lp.</th>
            <th>Przeznaczenie tuszy</th>
            <th>Miejsce skupu</th>
            <th>Znacznik tuszy</th>
            <th>Waga</th>
            <th>Myśliwy</th>
            <th>Imię i nazwisko</th>
        </tr>
        </thead>
        <tbody>
        
        
        </tbody>
        </table>
        `)

        let tableRow = $(`
                    <tr>
                        <td class="lp"></td>
                        <td>
                            <select name="multi_data[animal_intended_use_id][]" class="intended-use-id form-select"></select>
                        </td>
                        <td>
                            <select name="multi_data[collection_centre_id][]" class="collection-centre-id form-select"></select>
                        </td>
                        <td>
                            <input name="multi_data[identifier][]" class="identifier form-control" type="text"/>
                        </td>
                        <td>
                            <input name="multi_data[weight][]" class="weight form-control" type="number"  min="0" value="0"/>
                        </td>
                        <td>
                            <select name="multi_data[user_association_id][]" class="user-association-id form-select"></select>
                        </td>
                        <td>
                            <input name="multi_data[guest_full_name][]" class="guest-full-name form-control" type="text"/>
                        </td>
                    </tr>
                    `);

        let intendedUseOptions = $('#groupHuntingAddAnimal_animal_intended_use_id > option').clone();
        let userAssociationOptions = $('#groupHuntingAddAnimal_user_association_id > option').clone();

        tableRow.find('.intended-use-id').append(intendedUseOptions);
        tableRow.find('.collection-centre-id').append(collectionCentreOptions);
        tableRow.find('.user-association-id').append(userAssociationOptions);

        for (let i = 1; i <= quantity; i++) {

            if (tableRow.find('.lp').empty()) {
                tableRow.find('.lp').append(i);

            }
            table.append(tableRow.clone());

        }

        row.append(table.clone());

        row.find('.intended-use-id').bind('change', async function (e) {
            e.preventDefault();

            if (parseInt($(this).children("option:selected").val()) === 1) {
                $(this).closest('tr').find('.collection-centre-id').show();
            } else {
                $(this).closest('tr').find('.collection-centre-id').hide();
            }
        });

        row.find('.user-association-id').bind('change', async function (e) {
            e.preventDefault();

            if (parseInt($(this).children("option:selected").val()) === 0) {
                $(this).closest('tr').find('.guest-full-name').show();
            } else {
                $(this).closest('tr').find('.guest-full-name').hide();
            }
        });

    });

    $('.btn-back').on('click', async function (e) {
        e.preventDefault();

        $('.title-add').html('Dodaj zwierzyne');

        $('.dialog-add').removeClass('modal-lg modal-xl');

        $(".animal_types").show();
        $(".animals").show();
        $(".quantity").show();
        $(this).hide();
        $('.btn-next').show();
        $('.btn-decline').show();
        $('.btn-add').hide();

        $('.table-details').remove();

    });

    (() => {

        let editAnimalForm = $("#groupHuntingEditAnimal");
        let row, id = false;

        handleApiForm(editAnimalForm, function ({response}) {

            let modalInstance = bootstrap.Modal.getInstance(document.getElementById("editAnimalsModal"));
            modalInstance.hide();


            toastAlert('Zwierzyna została pomyślnie edytowana');

            let hunting_animal = response.data.hunting_animal;
            const collectionCentreName = hunting_animal.centre && hunting_animal.centre.short_name ? hunting_animal.centre.short_name : 'Brak';

            if(!hunting_animal.identifier){
                hunting_animal.identifier = '-'
            }
            if(!hunting_animal.identifier_district_veterinarian){
                hunting_animal.identifier_district_veterinarian = '-'
            }
            if(!hunting_animal.identifier_direct_sale){
                hunting_animal.identifier_direct_sale = '-'
            }

            row.find('.hunting_animal__display_name').text(hunting_animal.animal_display_name);
            // row.find('.hunting_animal__guest_full_name').text(hunting_animal.guest_full_name == null ? hunting_animal.user_display_name : hunting_animal.guest_full_name);
            row.find('.hunting_animal__animal_intended_use_name').text(hunting_animal.intendedUse.name);

            let number_mp = `${(hunting_animal.number_mp && hunting_animal.number_mp.length > 0) ? `<br />(Numer MP: ${hunting_animal.number_mp})` : ''}`;
            row.find('.hunting_animal__collection_centre_name').html(collectionCentreName + number_mp);

            row.find('.hunting_animal__identifier').text(hunting_animal.identifier + ' / ' + hunting_animal.identifier_district_veterinarian + ' / ' + hunting_animal.identifier_direct_sale);
            if (parseInt(hunting_animal.animal.type.is_big) === 1) {
                row.find('.hunting_animal__weight').text(parseFloat(hunting_animal.weight).toFixed(2));
            } else {
                row.find('.hunting_animal__weight').text('');
            }
            row.find('.hunting_animal__quantity').text(hunting_animal.quantity);
        })


        $("body").on('click', 'button[data-bs-target=\"#editAnimalsModal\"]', async function () {

            let spinner = new Spinner();
            row = $(`tr[data-id="${$(this).data('id')}"]`);

            id = row.data('id');

            editAnimalForm.find('input[name="id"]').val(id)
            editAnimalForm.attr('action', $(this).attr('data-edit-url'));

            try {
                let response = await axios.get($(this).data('url'));
                let hunting_animal = response.data.hunting_animal;
                let animal_values = response.data.animals;
                let animal_select = $('#groupHuntingEditAnimal_animal_id');
                let quantity_input = $('#groupHuntingEditAnimal_quantity');
                let user_association = $('#groupHuntingEditAnimal_user_association_id');

                console.log(response.data);


                animal_select.empty();

                for (let animal of animal_values) {
                    animal_select.append(`<option value=${animal.id}>${animal.name}</option>`);
                }

                $('#groupHuntingEditAnimal_animal_type_id').val(hunting_animal.animal.animal_type_id);

                if (parseInt(hunting_animal.animal.type.is_big) === 1) {
                    editAnimalForm.find(".weight").show();
                    quantity_input.attr('readonly', true);
                } else {

                    editAnimalForm.find(".weight").hide();
                    quantity_input.attr('readonly', false);
                }

                if(hunting_animal.animal.type.hasManyAnimals){
                    editAnimalForm.find(".animals").show();
                }else{
                    editAnimalForm.find(".animals").hide();
                }

                animal_select.val(hunting_animal.animal.id);
                quantity_input.val(hunting_animal.quantity);

                $('#groupHuntingEditAnimal_animal_intended_use_id').val(hunting_animal.animal_intended_use_id);
                if (parseInt(hunting_animal.animal_intended_use_id) === 1) {
                    editAnimalForm.find('.centres').show();
                } else {
                    editAnimalForm.find('.centres').hide();
                }
                $('#groupHuntingEditAnimal_collection_centre_id').val(hunting_animal.collection_centre_id ?? 0);
                $('#groupHuntingEditAnimal_number_mp').val(hunting_animal.number_mp);
                $('#groupHuntingEditAnimal_identifier').val(hunting_animal.identifier);
                $('#groupHuntingEditAnimal_identifier_district_veterinarian').val(hunting_animal.identifier_district_veterinarian);
                $('#groupHuntingEditAnimal_identifier_direct_sale').val(hunting_animal.identifier_direct_sale);

                $('#groupHuntingEditAnimal_weight').val(hunting_animal.weight);

                spinner.destroy();
            } catch (err) {
                toastAlert('Nie udało się załadować danych potrzebnych do dodania zwierzyny. Spróbuj ponownie później.', {type: 'danger'});
            }
        })
    })()

    // change visibility of collection centres based on intended use
    $('[name="animal_intended_use_id"]').on('change', function() {
        let value = $(this).val();
        const form = $(this).closest('form');

        if (parseInt(value) === 1) {
            form.find('.centres').show();
        } else {
            form.find('.centres').hide();
        }
    })

    $('#huntingEditAnimal_animal_type_id').on('change', async function (e) {
        e.preventDefault();

        let id = $(this).children("option:selected").val();

        try {

            let response = await axios.get(url(`api/app/dictionary/animals?type_id=${id}&only_from_plan=true`));
            let select = $("#huntingEditAnimal_animal_id");
            let quantity_input = $('#huntingEditAnimal_quantity');

            $(this).children("option[value='0']").remove();

            if (parseInt($(this).children("option:selected").data('is_big')) === 1) {
                quantity_input.val(1)
                quantity_input.attr('readonly', true);
                $('.edit-weight').show();

            } else {
                quantity_input.attr('readonly', false);
                $('.edit-weight').hide();
            }

            if($(this).children("option:selected").data('has_many_animals')){
                $('.edit-animals').show();
            }else{
                $('.edit-animals').hide();
            }

            select.empty();

            let data = response.data;

            for (let animal of data.animals) {
                select.append(`<option value=${animal.id}>${animal.name}</option>`);
            }

        } catch (err) {
            toastAlert('Wystąpił błąd podczas wyboru zwierzyny')
        }

    });

    $('#huntingEditAnimal_animal_intended_use_id').on('change', async function (e) {
        e.preventDefault();

        if (parseInt($(this).children("option:selected").val()) === 1) {
            $('.edit-centres').show();
        } else {
            $('.edit-centres').hide();
        }
    });


    $('#huntingEditAnimal_user_association_id').on('change', async function (e) {

        e.preventDefault();

        if (parseInt($(this).children("option:selected").val()) === 0) {
            $('.edit-guest_full_name').show();
        } else {
            $('.edit-guest_full_name').hide();
        }
    });

    $('#form').on('submit', function(){
        enableFormBack(this);
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("pdfModal"));
        modalInstance.hide()
    })

    let add_participant_modal = $("#addParticipant");
    let p_modal_title = add_participant_modal.find('.modal-title');
    let p_modal_first_name_label = add_participant_modal.find("label[for='huntingAddParticipant_first_name']");
    let p_modal_type_input = add_participant_modal.find("#type_id");
    let p_modal_last_name = add_participant_modal.find('.last_name');
    let p_modal_first_name_input = add_participant_modal.find('.first_name').find('input');

    $('#addGuest').click(function (){
        p_modal_title.html('Dodaj gościa');
        p_modal_first_name_label.html('Imię');
        p_modal_first_name_input.attr('placeholder', 'Imię');
        p_modal_type_input.val(1);
        p_modal_last_name.show();

    })

    $('#addBarker').click(function (){
        p_modal_title.html('Dodaj naganiacza');
        p_modal_first_name_label.html('Imię');
        p_modal_first_name_input.attr('placeholder', 'Imię');
        p_modal_type_input.val(2);
        p_modal_last_name.show();

    })

    $('#addDog').click(function (){
        p_modal_title.html('Dodaj psa');
        p_modal_first_name_label.html('Nazwa')
        p_modal_last_name.hide();
        p_modal_type_input.val(3);
        p_modal_first_name_input.attr('placeholder', 'Nazwa');

    })

    $('#timesheetMembers').DataTable({
        stateSave: false,
        order: [1, 'asc'],
        columnDefs: [
            {
                'targets': 1,
                'type': 'polstring'
            },
            {
                'targets': 0,
                'type': 'polstring'
            }
        ]
    });

    $('#timesheetGuests').DataTable({
        stateSave: false,
        order: [1, 'asc'],
        columnDefs: [
            {
                'targets': 1,
                'type': 'polstring'
            },
            {
                'targets': 0,
                'type': 'polstring'
            }
        ]
    });

    $('#timesheetBarkers').DataTable({
        stateSave: false,
        order: [1, 'asc'],
        columnDefs: [
            {
                'targets': 1,
                'type': 'polstring'
            },
            {
                'targets': 0,
                'type': 'polstring'
            }
        ]
    });

    $('#timesheetDogs').DataTable({
        stateSave: false,
        order: [0, 'asc'],
        columnDefs: [
            {
                'targets': 0,
                'type': 'polstring'
            },
        ]
    });

    let availableMembersList = $('#availableMembersList').DataTable({
        stateSave: false,
        pageLength: -1,
        order: [2, 'asc'],
        columnDefs: [
            {
                'targets': 2,
                'type': 'polstring'
            }
        ]
    });

    let availableGuestsList = $('#availableGuestsList').DataTable({
        stateSave: false,
        pageLength: -1,
        order: [2, 'asc'],
        columnDefs: [
            {
                'targets': 2,
                'type': 'polstring'
            }
        ]
    });

    let availableCommercialsList = $('#availableCommercialsList').DataTable({
        stateSave: false,
        pageLength: -1,
        order: [2, 'asc'],
        columnDefs: [
            {
                'targets': 2,
                'type': 'polstring'
            }
        ]
    });

    if(availableMembersList.length > 0) {
        $("#addMemberToHunting").submit(function (e) {
            e.preventDefault();

            let inputs = availableMembersList.DataTable().$('input');

            for(let input of inputs) {

                if($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="members_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        })
    }

    if(availableGuestsList.length > 0) {
        $("#addGuestToHunting").submit(function (e) {
            e.preventDefault();

            let inputs = availableGuestsList.DataTable().$('input');

            for(let input of inputs) {

                if($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="members_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        })
    }

    if(availableCommercialsList.length > 0) {
        $("#addCommercialToHunting").submit(function (e) {
            e.preventDefault();

            let inputs = availableCommercialsList.DataTable().$('input');

            for(let input of inputs) {

                if($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="members_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        })
    }

    let edit_first_name = $('#huntingEditParticipant_first_name');
    let edit_last_name = $('#huntingEditParticipant_last_name');
    let edit_comments = $('#huntingEditParticipant_comments');
    let participant_id = $('#participant_id');

    let edit_participant_modal = $("#editParticipant");
    let edit_modal_title = edit_participant_modal.find('.modal-title');
    let edit_modal_first_name_label = edit_participant_modal.find("label[for='huntingEditParticipant_first_name']");
    let edit_modal_last_name = edit_participant_modal.find('.last_name');

    $('.editDogBtn, .editBarkerBtn, .editGuestBtn').click(function(){

        let title = '';
        edit_first_name.val($(this).closest('tr').find('.first_name').html());
        edit_last_name.val($(this).closest('tr').find('.last_name').html());
        edit_comments.val($(this).closest('tr').find('.comments').html());
        participant_id.val($(this).data('id'));

        if($(this).hasClass('editDogBtn')){
            title = 'Edytuj dane psa';
            edit_modal_last_name.hide();
            edit_modal_first_name_label.html('Nazwa');
        }
        else if($(this).hasClass('editGuestBtn')){
            edit_modal_first_name_label.html('Imię');
            edit_modal_last_name.show();
            title = 'Edytuj dane gościa';
        }
        else if($(this).hasClass('editBarkerBtn')){
            edit_modal_first_name_label.html('Imię');
            edit_modal_last_name.show();
            title = 'Edytuj dane naganiacza';
        }

        edit_modal_title.html(title);

    })

    $('.editMemberBtn').click(function(){
        let modal = $('#editMemberModal');
        modal.find('#id').val($(this).data('id'));
        modal.find('#comments').val($(this).closest('tr').find('.comments').html());
    })

    $('#btnAddNextParticipant').click(function(){
        let form = $('#huntingAddParticipant');
        let action = form[0].action;
        action = action + '?add_next=1';
        form[0].action = action;
        form[0].submit();
    })

    $('.cloneHuntingBtn').click(function(){
        let id = $(this).data('id');
        $('#hunting_id').val(id);
    })

}